import React, { useState } from 'react';
import PropTypes from 'prop-types';
import ContextPlayer from 'components/ContextPlayer';
import Favorite from 'components/Favorite';
import { PAGE_TYPE_WATCH_FREE } from 'helpers/ContentHelper';
import { isMobileBreakpoint } from 'helpers/BreakpointHelper';

import {
  getHeroContextPlayerProps,
  getHeroFavoriteButtonProps,
  getHeroPlayButtonProps,
  getHeroRestartButtonProps,
  getHeroTrailerButtonProps,
  getHeroCommonProps,
} from './HeroHelper';

import ActionButton from './components/ActionButton';
import Description from './components/Description';
import ProgressBar from './components/ProgressBar';
import TitleLink from './components/TitleLink';
import TuneIn from './components/TuneIn';
import Meta from './components/Meta';
import SecondaryButtons from './components/SecondaryButtons';
import Divider from '../Divider';

import Style from './Hero.module.scss';
import ButtonStyle from './components/ActionButton/ActionButton.module.scss';

const Hero = props => {
  const { breakpoint, item } = props;
  const [playerVisibility, setPlayerVisibility] = useState(false);
  if (!item) return null;
  const { retired, id } = item;
  const componentProps = { ...props, playerVisibility, setPlayerVisibility };
  const shouldShowFavoriteButton = !retired && id !== PAGE_TYPE_WATCH_FREE;

  return (
    <>
      <div className={Style.header}>
        <ContextPlayer {...getHeroContextPlayerProps(componentProps)} />
        <div className={Style.content}>
          <TitleLink {...getHeroCommonProps(componentProps)} />
          <div>
            <Meta {...getHeroCommonProps(componentProps)} />
            <Description {...getHeroCommonProps(componentProps)} />
            <TuneIn {...getHeroCommonProps(componentProps)} />
            <ProgressBar {...getHeroCommonProps(componentProps)} />
            <div className={Style.actionButtons}>
              <ActionButton {...getHeroPlayButtonProps(componentProps)} />
              <ActionButton {...getHeroRestartButtonProps(componentProps)} />
              {isMobileBreakpoint(breakpoint) ? (
                <SecondaryButtons {...componentProps} />
              ) : (
                <>
                  {shouldShowFavoriteButton ? (
                    <div className={ButtonStyle.actionLink}>
                      <Favorite {...getHeroFavoriteButtonProps(componentProps)} />
                    </div>
                  ) : null}
                  <ActionButton {...getHeroTrailerButtonProps(componentProps)} />
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Divider />
    </>
  );
};

Hero.propTypes = {
  breakpoint: PropTypes.string.isRequired,
  item: PropTypes.shape({}).isRequired,
};

export default React.memo(Hero);
